export const AUTH_METHODS = ["discord", "local", "both"] as const;
export type AuthMethod = (typeof AUTH_METHODS)[number];

export const AUTH_MODES = ["discord", "local", "both"] as const;
export type AuthMode = (typeof AUTH_MODES)[number];

export const PRODUCT_TYPES = ["digitalPaid", "digitalFree", "service", "serials", "account", "multiPrice"] as const;
export type ProductType = (typeof PRODUCT_TYPES)[number];

export const PAYMENT_METHODS = ["paypal", "paypal-standard", "stripe", "coinbase", "nowpayments", "manual"] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const CHECKOUT_PROVIDERS = ["paypal", "paypal-standard", "stripe", "coinbase", "nowpayments"] as const;
export type CheckoutProvider = (typeof CHECKOUT_PROVIDERS)[number];

export const SALE_EVENT_TYPES = [
  "black-friday",
  "christmas",
  "easter",
  "new-year",
  "summer",
  "halloween",
  "valentines",
  "cyber-monday",
] as const;
export type SaleEventType = (typeof SALE_EVENT_TYPES)[number];

export const HOLIDAY_EFFECT_TYPES = [
  "christmas",
  "halloween",
  "valentines",
  "new-year",
  "easter",
  "black-friday",
] as const;
export type HolidayEffectType = (typeof HOLIDAY_EFFECT_TYPES)[number];

export const STAFF_PERMISSIONS = [
  "canCreateProducts",
  "canUpdateProducts",
  "canDeleteProducts",
  "canAddProducts",
  "canRemoveProducts",
  "canViewInvoices",
  "canManageDiscounts",
  "canManageSales",
  "canManageAntiPiracy",
  "canManageLicenses",
] as const;
export type StaffPermission = (typeof STAFF_PERMISSIONS)[number];

export const STAFF_PERMISSION_LABELS: Record<StaffPermission, string> = {
  canCreateProducts: "Create products",
  canUpdateProducts: "Update products",
  canDeleteProducts: "Delete products",
  canAddProducts: "Grant products to users",
  canRemoveProducts: "Remove products from users",
  canViewInvoices: "View invoices",
  canManageDiscounts: "Manage discount codes",
  canManageSales: "Manage sales",
  canManageAntiPiracy: "Manage anti-piracy",
  canManageLicenses: "Manage licenses",
};

export const CART_SNAPSHOT_STATUSES = ["pending", "processed", "expired", "failed"] as const;
export type CartSnapshotStatus = (typeof CART_SNAPSHOT_STATUSES)[number];

export const LICENSE_LOG_TYPES = ["Accepted", "Denied"] as const;
export type LicenseLogType = (typeof LICENSE_LOG_TYPES)[number];

export const EMAIL_PROVIDERS = ["smtp", "sendgrid", "resend"] as const;
export type EmailProvider = (typeof EMAIL_PROVIDERS)[number];

export const FEATURE_LAYOUTS = ["normal", "wide"] as const;
export type FeatureLayout = (typeof FEATURE_LAYOUTS)[number];
